import React, {ReactElement} from "react";
import { gql, 
    useMutation 
} from "@apollo/client";
import { ValidatePinMutationMutation, ValidatePinMutationMutationVariables } from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

const validatePinMutation = gql`
  mutation ValidatePinMutation(
    $pin: String!
    ) {
    validatePin(pin: $pin) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitValidatePin: (
        values: ValidatePinMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error: any;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const ValidatePinController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    ValidatePinMutationMutation,
    ValidatePinMutationMutationVariables
  >(validatePinMutation);

  const submitValidatePin = async (values: ValidatePinMutationMutationVariables) => {
    const { data: {validatePin} }:any = await mutate({ variables: values });

    if (validatePin.errors) {
      return normalizeErrors(validatePin.errors);
    }

    return null;
  };

  const message = data?.validatePin?.message || null;

  return children({
    submitValidatePin,
    loading,
    error,
    message,
  });
};
